// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2SL5q","notes":"Notes_notes__3xWP7","note":"Notes_note__1FhNM","markdown":"Notes_markdown__21NCU"};